import { useCallback, useMemo } from 'react';
import debounce from 'lodash.debounce';
import memoizeOne from 'memoize-one';

// Not yet implemented for a soon to be react-i18n who handle this
import localizations from '../localizations.json';

import useLanguage from './useLanguage.js';

const missingTranslations: Record<string, Record<string, string>> = {};

export const warnMissingTranslations = debounce(
  memoizeOne((content) => {
    console.warn(`No translation found for:
${content}
  `);
  }),
  5000
);

export const registerMissingTranslation = (literal: string, locale: string) => {
  missingTranslations[locale] = {
    ...missingTranslations[locale],
    [literal]: '',
  };
  warnMissingTranslations.cancel();
  warnMissingTranslations(JSON.stringify(missingTranslations, null, 2));
};

export const useTranslate = (): ((literal: string) => string) => {
  const { locale } = useLanguage();

  const translations = useMemo(
    () => ((localizations as any)[locale] ? (localizations as any)[locale] : {}),
    [locale]
  );

  return useCallback(
    (literal: string) => {
      const translatedText = translations[literal];
      if (import.meta.env.DEV) {
        // Omit this warning for english locale due it's the default one
        if (!translatedText && locale !== 'en') {
          registerMissingTranslation(literal, locale);
        }
      }
      // We should use the literal as fallback
      return translatedText || literal;
    },
    [locale, translations]
  );
};

export default useTranslate;
